var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data-testid":"balances"}},[(_vm.isLoading)?_c('BalancesLoader'):_c('div',{staticClass:"balances"},[_c('HeadingDisplay',{attrs:{"head":"Saldo disponível em conta","title":_vm.balance,"subtitle":_vm.balanceLastUpdatedAt}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }